import { Injectable } from '@angular/core';
import { FormGroupDescription, GridColumnDescription, IColumnDescription } from './adapter_t';
import { IModelMetadata, nameof, TwoWayAdapter } from '@bds/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

export interface RtCommodityShippedErrorsUK {
    carInit?: string;
    carNo?: string;
    shipDate?: Date;
    commodityCompart?: number;
    ormId?: number;
    rtTripErrorsOrmId?: number;
    commodityAmt?: number;
    commodityUnits?: string;
    commodityRef1?: string;
    commodityRef2?: string;
    commodityRef3?: string;
    commodityRef4?: string;
    updateDateTime?: Date;
}

export class RtCommodityShippedErrors implements RtCommodityShippedErrorsUK {
    constructor(
        public carInit?: string,
        public carNo?: string,
        public commodityCompart?: number,
        public shipDate?: Date,
        public commodityCode?: string,
        public commodityAmt?: number,
        public commodityUnits?: string,
        public commodityRef1?: string,
        public commodityRef2?: string,
        public commodityRef3?: string,
        public commodityRef4?: string,
        public ormId?: number,
        public rtTripErrorsOrmId?: number,
        public userId?: string,
        public updateDateTime?: Date,
    ) {}

    static from(trip: RtCommodityShippedErrors): RtCommodityShippedErrors {
        const obj = new RtCommodityShippedErrors();
        Object.keys(trip).forEach((k) => (obj[k] = trip[k]));
        return obj;
    }
}

export var relationship: IModelMetadata[] = [
    { client: nameof<RtCommodityShippedErrors>('carInit'), server: 'carInit' },
    { client: nameof<RtCommodityShippedErrors>('carNo'), server: 'carNo' },
    { client: nameof<RtCommodityShippedErrors>('commodityCompart'), server: 'commodityCompart' },
    { client: nameof<RtCommodityShippedErrors>('shipDate'), server: 'shipDate' },
    { client: nameof<RtCommodityShippedErrors>('commodityCode'), server: 'commodityCode' },
    { client: nameof<RtCommodityShippedErrors>('commodityAmt'), server: 'commodityAmt' },
    { client: nameof<RtCommodityShippedErrors>('commodityUnits'), server: 'commodityUnits' },
    { client: nameof<RtCommodityShippedErrors>('commodityRef1'), server: 'commodityRef1' },
    { client: nameof<RtCommodityShippedErrors>('commodityRef2'), server: 'commodityRef2' },
    { client: nameof<RtCommodityShippedErrors>('commodityRef3'), server: 'commodityRef3' },
    { client: nameof<RtCommodityShippedErrors>('commodityRef4'), server: 'commodityRef4' },
    { client: nameof<RtCommodityShippedErrors>('ormId'), server: 'ormId' },
    { client: nameof<RtCommodityShippedErrors>('rtTripErrorsOrmId'), server: 'rtTripErrorsOrmId' },
    { client: nameof<RtCommodityShippedErrors>('userId'), server: 'userId' },
    { client: nameof<RtCommodityShippedErrors>('updateDateTime'), server: 'updateDateTime' },
];

@Injectable({
    providedIn: 'root',
})
export class RtCommodityShippedErrorsAdapter extends TwoWayAdapter<RtCommodityShippedErrors> {
    constructor() {
        super();
    }

    public metadata: IModelMetadata[] = relationship;
}

// https://www.devexpress.com/Support/Center/Question/Details/T746351/datagrid-how-to-set-columns-at-runtime
@Injectable({
    providedIn: 'root',
})
export class RtCommodityShippedErrorsMetadata
    implements GridColumnDescription, FormGroupDescription
{
    getColumns(defaultVisibility: boolean = true): IColumnDescription[] {
        const columns = [
            {
                dataField: nameof<RtCommodityShippedErrors>('carInit'),
                dataType: 'string',
                caption: 'carInit',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('carNo'),
                dataType: 'string',
                caption: 'carNo',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityCompart'),
                dataType: 'number',
                caption: 'commodityCompart',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('shipDate'),
                dataType: 'Date',
                caption: 'shipDate',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityCode'),
                dataType: 'string',
                caption: 'commodityCode',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityAmt'),
                dataType: 'number',
                caption: 'commodityAmt',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityUnits'),
                dataType: 'string',
                caption: 'commodityUnits',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityRef1'),
                dataType: 'string',
                caption: 'commodityRef1',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityRef2'),
                dataType: 'string',
                caption: 'commodityRef2',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityRef3'),
                dataType: 'string',
                caption: 'commodityRef3',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('commodityRef4'),
                dataType: 'string',
                caption: 'commodityRef4',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('ormId'),
                dataType: 'number',
                caption: 'ormId',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('rtTripErrorsOrmId'),
                dataType: 'number',
                caption: 'rtTripOrmId',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('userId'),
                dataType: 'string',
                caption: 'userId',
                visible: defaultVisibility,
            } as IColumnDescription,
            {
                dataField: nameof<RtCommodityShippedErrors>('updateDateTime'),
                dataType: 'Date',
                caption: 'updateDateTime',
                visible: defaultVisibility,
            } as IColumnDescription,
        ];
        return columns;
    }

    getFormGroup(obj?: any): UntypedFormGroup {
        const formGroup = new UntypedFormGroup({});
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('carInit'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(nameof<RtCommodityShippedErrors>('carNo'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityAmt'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityCode'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityCompart'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityRef1'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityRef2'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityRef3'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityRef4'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('commodityUnits'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(nameof<RtCommodityShippedErrors>('ormId'), new UntypedFormControl(''));
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('rtTripErrorsOrmId'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('shipDate'),
            new UntypedFormControl('', [Validators.required]),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('updateDateTime'),
            new UntypedFormControl(''),
        );
        formGroup.addControl(
            nameof<RtCommodityShippedErrors>('userId'),
            new UntypedFormControl(''),
        );

        if (!!obj) {
            formGroup.setValue(obj);
        }
        return formGroup;
    }
}
